import React, { useLayoutEffect, useState } from "react";

import PropTypes from "prop-types";
import { Link, graphql, StaticQuery } from "gatsby";
import { Carousel } from "react-responsive-carousel";
import PreviewCompatibleImage from "./PreviewCompatibleImage";
import sale from "../img/sale.svg";
import testimonialsStatic from "../json/reviews-static.json";

function shuffle(array) {
  return [...array].sort(() => Math.random() - 0.5);
}

// Function to get a random element from array
function getRandomElement(array) {
  return array[Math.floor(Math.random() * array.length)];
}

class ProductsWithTestimonialsTemplate extends React.PureComponent {
  // outside of the render scope
  constructor(props) {
    super(props);
    this.state = { width: 0, height: 0 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {
    let { data } = this.props;

    let { edges: products } = data.allMarkdownRemark;
    let { edges: testimonials } = data.allGoogleRating;

    if (!data.allGoogleRating) {
      let testimonial;
    }

    if (!testimonials) {
      return null;
    }

    let stars = [];

    stars[5] = <>&#11088;&#11088;&#11088;&#11088;&#11088;</>;
    stars[4] = <>&#11088;&#11088;&#11088;&#11088</>;
    stars[3] = <>&#11088;&#11088;&#11088</>;
    stars[2] = <>&#11088;&#11088;</>;
    stars[1] = <>&#11088;</>;

    // remove all testimonials that are too short
    let filteredTestimonials,
      testimonialWordCount = 30;

    if (testimonials[0].node.review.length) {
      filteredTestimonials = testimonials.filter(
        (testimonial) =>
          testimonial.node.review &&
          testimonial.node.review.split(" ").length >= testimonialWordCount
      );
    }
    testimonials = [];
    filteredTestimonials.forEach((testimonial) => {
      testimonials.push({
        quote: testimonial.node.review,
        author: testimonial.node.name,
        rating: stars[testimonial.node.rating],
      });
    });

    let selectedProducts, selectedTestimonials;

    // shuffle the testimonials
    testimonials = shuffle(testimonials);

    // Create a new array
    let selectedProductsId = [];

    // Loop to add 4 ids to the new array
    for (let i = 0; i < 4; i++) {
      let randomElement = getRandomElement(products);

      // Check to make sure we don't have duplicates
      while (selectedProductsId.includes(randomElement.node.id)) {
        randomElement = getRandomElement(products);
      }

      selectedProductsId.push(randomElement.node.id);
    }
    selectedProducts = [];
    products.forEach((element) => {
      if (selectedProductsId.includes(element.node.id)) {
        selectedProducts.push(element);
      }
    });

    // shuffle the testimonials

    selectedTestimonials = testimonials.slice(0, 2);
    //console.log(
    //  "SELPRODUCTS-----------------------------------------------------------------"
    //);
    //console.log(selectedProducts);
    //console.log(
    //  "SELPRODUCTS-----------------------------------------------------------------"
    //);

    return (
      <>
        <div className="columns m-0 p-0">
          <div className="column is-6 light-cammo m-0 p-0">
            <div className="section section--gradient">
              <div className="container content has-text-centered">
                <Carousel
                  centerMode={!!(this.state.width > 768)}
                  centerSlidePercentage={50}
                  showArrows={true}
                  infiniteLoop={true}
                  showThumbs={false}
                  showStatus={false}
                  autoPlay={true}
                  interval={7100}
                  showIndicators={false}
                >
                  {products
                    .slice(0, products.length / 2)
                    .map((el) =>
                      displayProduct(el, this.state.width > 768 ? 2 : 1)
                    )}
                </Carousel>
              </div>
            </div>
          </div>
          <div className="column is-6 m-0 px-0 is-white-bg">
            <div className="section section--gradient">
              <div className="testimonial-carousel content box">
                <Carousel
                  showArrows={true}
                  infiniteLoop={true}
                  showThumbs={false}
                  showStatus={false}
                  autoPlay={true}
                  interval={7100}
                  showIndicators={true}
                >
                  {testimonialsStatic.partOne.map((testimonial) => (
                    <div className="container p-4">
                      <h3
                        className="has-text-weight-normal is-size-5"
                        style={{
                          maxHeight: "4.5em",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                        }}
                      >
                        {testimonial.review?.length > 250
                          ? `${testimonial.review?.substring(0, 250)} ...`
                          : testimonial.review}
                      </h3>
                      <h2 className="has-text-weight-normal is-size-6 has-text-right">
                        &mdash; {testimonial.name},
                        <br clear="right" />
                        &#11088;&#11088;&#11088;&#11088;&#11088;
                      </h2>
                    </div>
                  ))}
                </Carousel>
              </div>
              <div className="testimonial-carousel content box">
                <Carousel
                  showArrows={true}
                  infiniteLoop={true}
                  showThumbs={false}
                  showStatus={false}
                  autoPlay={true}
                  interval={7100}
                  showIndicators={true}
                >
                  {testimonialsStatic.partTwo.map((testimonial) => (
                    <div className="container p-4">
                      <h3 className="has-text-weight-normal is-size-5">
                        {testimonial.review?.length > 250
                          ? `${testimonial.review?.substring(0, 250)} ...`
                          : testimonial.review}
                      </h3>
                      <h2 className="has-text-weight-normal is-size-6 has-text-right">
                        &mdash; {testimonial.name},
                        <br clear="right" />
                        &#11088;&#11088;&#11088;&#11088;&#11088;
                      </h2>
                    </div>
                  ))}
                </Carousel>
              </div>
            </div>
          </div>
        </div>
        <div className="columns m-0 p-0 ">
          <div className="column is-white-bg is-6">
            <div className="section">
              <div className="testimonial-carousel content box">
                <Carousel
                  showArrows={true}
                  infiniteLoop={true}
                  showThumbs={false}
                  showStatus={false}
                  autoPlay={true}
                  interval={7100}
                  showIndicators={true}
                >
                  {testimonialsStatic.partThree.map((testimonial) => (
                    <div className="container p-4">
                      <h3 className="has-text-weight-normal is-size-5">
                        {testimonial.review?.length > 250
                          ? `${testimonial.review?.substring(0, 250)} ...`
                          : testimonial.review}
                      </h3>
                      <h2 className="has-text-weight-normal is-size-6 has-text-right">
                        &mdash; {testimonial.name},
                        <br clear="right" />
                        &#11088;&#11088;&#11088;&#11088;&#11088;
                      </h2>
                    </div>
                  ))}
                </Carousel>
              </div>
              <div className="testimonial-carousel content box">
                <Carousel
                  showArrows={true}
                  infiniteLoop={true}
                  showThumbs={false}
                  showStatus={false}
                  autoPlay={true}
                  interval={7100}
                  showIndicators={true}
                >
                  {testimonialsStatic.partFour.map((testimonial) => (
                    <div className="container p-4">
                      <h3 className="has-text-weight-normal is-size-5">
                        {testimonial.review?.length > 250
                          ? `${testimonial.review?.substring(0, 250)} ...`
                          : testimonial.review}
                      </h3>
                      <h2 className="has-text-weight-normal is-size-6 has-text-right">
                        &mdash; {testimonial.name},
                        <br clear="right" />
                        &#11088;&#11088;&#11088;&#11088;&#11088;
                      </h2>
                    </div>
                  ))}
                </Carousel>
              </div>
            </div>
          </div>
          <div className="column is-6 light-cammo m-0 p-0">
            <div className="section section--gradient">
              <div className="container content has-text-centered">
                <Carousel
                  centerMode={!!(this.state.width > 768)}
                  centerSlidePercentage={50}
                  showArrows={true}
                  infiniteLoop={true}
                  showThumbs={false}
                  showStatus={false}
                  autoPlay={true}
                  interval={7100}
                  showIndicators={false}
                >
                  {products
                    .slice(products.length / 2, products.length)
                    .map((el) =>
                      displayProduct(el, this.state.width > 768 ? 2 : 1)
                    )}
                </Carousel>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

ProductsWithTestimonials.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
};

export default function ProductsWithTestimonials(arg) {
  return (
    <StaticQuery
      query={graphql`
        query ProductsWithTestimonialsQuery {
          allMarkdownRemark(
            sort: { frontmatter: { title: ASC } }
            filter: { frontmatter: { templateKey: { eq: "store-post" } } }
          ) {
            edges {
              node {
                id
                fields {
                  slug
                }
                frontmatter {
                  title
                  product {
                    salePrice
                    price
                    brand
                    category
                    images {
                      image {
                        childImageSharp {
                          gatsbyImageData(
                            quality: 100
                            layout: FULL_WIDTH
                            placeholder: BLURRED
                          )
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          allGoogleRating {
            edges {
              node {
                name
                rating
                review
              }
            }
          }
        }
      `}
      render={(data, count) => (
        <ProductsWithTestimonialsTemplate data={data} count={count} arg={arg} />
      )}
    />
  );
}

const currency = function (number) {
  if (
    number !== "Varies" &&
    number !== "Price Varies" &&
    number !== "$NaN" &&
    number !== "$NaN Per Rider" &&
    number
  ) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    }).format(number);
  } else {
    return "Price Varies";
  }
};

const displayProduct = function (product, column = 1) {
  let rawPrice, priceDisplay;

  let slug = product.node.fields.slug;
  product = product.node.frontmatter;

  let title = product.title;
  let { salePrice, price, images } = product.product;

  if (salePrice) {
    rawPrice = salePrice;
    let percentage = Math.round((salePrice / price) * 100, 2);
    percentage = 100 - percentage;
    price = currency(price);
    salePrice = currency(salePrice);

    priceDisplay = (
      <>
        <h3 className="mt-0 pt-0 has-text-weight-semibold is-size-6 has-text-white">
          {salePrice} <strike className="has-text-grey-lighter">{price}</strike>{" "}
          <img src={sale} alt={`Save ${percentage}%`} className="sale-icon" />
        </h3>
      </>
    );
    price = salePrice;
  } else {
    price = currency(price);
    priceDisplay = (
      <h3 className="mt-0 pt-0 has-text-weight-semibold is-size-6">{price}</h3>
    );
    price = priceDisplay;
  }

  return (
    <div style={{ transform: `translateX(${100 - 100 / column}%)` }}>
      <center>
        <>
          <Link to={slug} title={title}>
            <PreviewCompatibleImage
              imageInfo={{
                image: images[0].image,
                alt: title,
                className: "max-img-400 p-4",
              }}
            />
          </Link>
          <Link to={slug} title={title}>
            <h2 className="pt-2 mb-0 pb-0 has-text-weight-bold is-size-5 has-text-white">
              {title}
            </h2>
          </Link>
        </>
      </center>
      {priceDisplay}
    </div>
  );
};
